"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _react = _interopRequireWildcard(require("react"));

require("./_style.scss");

var _settings = _interopRequireDefault(require("../../settings"));

var RadioInput = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(RadioInput, _Component);

  var _super = (0, _createSuper2["default"])(RadioInput);

  function RadioInput(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, RadioInput);
    _this = _super.call(this, props);
    _this.inputRef = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }

  (0, _createClass2["default"])(RadioInput, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          id = _this$props.id,
          name = _this$props.name,
          value = _this$props.value,
          checked = _this$props.checked,
          _onChange = _this$props.onChange,
          children = _this$props.children,
          className = _this$props.className,
          rest = (0, _objectWithoutProperties2["default"])(_this$props, ["id", "name", "value", "checked", "onChange", "children", "className"]);
      var finalClass = "radio-input-container ".concat(className || '');
      var background = "url(\"".concat(_settings["default"].iconPath, "/radio-").concat(checked ? 'selected' : 'unselected', ".svg\")");
      return /*#__PURE__*/_react["default"].createElement("div", Object.assign({
        className: finalClass,
        onClick: function onClick() {
          return _this2.inputRef.current.click();
        }
      }, rest), /*#__PURE__*/_react["default"].createElement("input", {
        type: "radio",
        id: id,
        name: name,
        value: value,
        checked: checked,
        onChange: function onChange(event) {
          return !_onChange ? null : _onChange(event);
        },
        ref: this.inputRef
      }), /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: id
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "radio-input-background",
        style: {
          background: background
        }
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "radio-input-background-child"
      })), /*#__PURE__*/_react["default"].createElement("span", {
        className: "radio-input-child-content ".concat(checked ? 'checked' : 'unchecked')
      }, children)));
    }
  }]);
  return RadioInput;
}(_react.Component);

var _default = RadioInput;
exports["default"] = _default;